import { request } from '@/api/_service.js';
export function listWarehouse(params) {
  return request({
    url: '/insideNew/getWarehouseList',
    method: 'get',
    params: params
  });
}